import { Outlet } from 'react-router';
import { OfflineStrip } from '@dd/ui';
import { TopBar } from './TopBar';
import { BottomNav } from './BottomNav';
import { FloatingHelp } from './FloatingHelp';
import { useSync } from '@/sync/status';
import { useT } from '@/lib/i18n';
import { UpgradeBanner } from './UpgradeBanner';
import { InnerCtx } from './innerCtx';
import { SideNav } from './SideNav';

/** Shell of the four main tabs: Top Bar + fixed Bottom Bar + floating WhatsApp help. */
export function MainLayout() {
  const online = useSync((s) => s.online);
  const { t } = useT();
  return (
    <div className="min-h-dvh bg-canvas lg:pl-64">
      <SideNav />
      <div className="flex min-h-dvh flex-col">
        <TopBar />
        {!online && <OfflineStrip label={t('অফলাইন — ডেটা ফোনে সেভ হচ্ছে, নেট এলে নিজেই সিঙ্ক হবে', 'Offline — saved on this phone, will sync when you are back online')} />}
        <UpgradeBanner />
        <main className="mx-auto w-full max-w-5xl flex-1 px-3 pb-28 sm:px-4 md:max-w-5xl lg:max-w-6xl lg:px-6 lg:pb-12 xl:max-w-7xl">
          <InnerCtx.Provider value><Outlet /></InnerCtx.Provider>
        </main>
      </div>
      <BottomNav />
      <FloatingHelp />
    </div>
  );
}
